import YogaHome from './YogaHome'

export default YogaHome
// eslint-disable-next-line import/export
export * from './YogaHome'
